export default "__VITE_ASSET__BFhpQmT$__"